/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  HTTPValidationError,
  ListTrajectoriesApiTrajectoriesGetParams,
  RunListResponse,
  TrajectoryImportRequest,
  TrajectoryImportResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listTrajectoriesApiTrajectoriesGetResponse200 = {
  data: RunListResponse;
  status: 200;
};

export type listTrajectoriesApiTrajectoriesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTrajectoriesApiTrajectoriesGetResponseSuccess =
  listTrajectoriesApiTrajectoriesGetResponse200 & {
    headers: Headers;
  };
export type listTrajectoriesApiTrajectoriesGetResponseError =
  listTrajectoriesApiTrajectoriesGetResponse422 & {
    headers: Headers;
  };

export type listTrajectoriesApiTrajectoriesGetResponse =
  | listTrajectoriesApiTrajectoriesGetResponseSuccess
  | listTrajectoriesApiTrajectoriesGetResponseError;

export const getListTrajectoriesApiTrajectoriesGetUrl = (
  params?: ListTrajectoriesApiTrajectoriesGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["tags"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/trajectories?${stringifiedParams}`
    : `/api/trajectories`;
};

/**
 * The team's runs as the Trajectories page lists them. Each row
 * carries the conversation's preview, so opening the list is recorded
 * in the team's audit log (TRA-1626); the search text is not.
 * @summary List Trajectories
 */
export const listTrajectoriesApiTrajectoriesGet = async (
  params?: ListTrajectoriesApiTrajectoriesGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTrajectoriesApiTrajectoriesGetResponse> => {
  return orvalFetch<listTrajectoriesApiTrajectoriesGetResponse>(
    getListTrajectoriesApiTrajectoriesGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTrajectoriesApiTrajectoriesGetQueryKey = (
  params?: ListTrajectoriesApiTrajectoriesGetParams,
) => {
  return [`/api/trajectories`, ...(params ? [params] : [])] as const;
};

export const getListTrajectoriesApiTrajectoriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTrajectoriesApiTrajectoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTrajectoriesApiTrajectoriesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>
  > = ({ signal }) =>
    listTrajectoriesApiTrajectoriesGet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTrajectoriesApiTrajectoriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>
>;
export type ListTrajectoriesApiTrajectoriesGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTrajectoriesApiTrajectoriesGet<
  TData = Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListTrajectoriesApiTrajectoriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
          TError,
          Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrajectoriesApiTrajectoriesGet<
  TData = Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTrajectoriesApiTrajectoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
          TError,
          Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrajectoriesApiTrajectoriesGet<
  TData = Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTrajectoriesApiTrajectoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Trajectories
 */

export function useListTrajectoriesApiTrajectoriesGet<
  TData = Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTrajectoriesApiTrajectoriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTrajectoriesApiTrajectoriesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTrajectoriesApiTrajectoriesGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type importLangsmithTrajectoryApiTrajectoriesImportPostResponse200 = {
  data: TrajectoryImportResponse;
  status: 200;
};

export type importLangsmithTrajectoryApiTrajectoriesImportPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type importLangsmithTrajectoryApiTrajectoriesImportPostResponseSuccess =
  importLangsmithTrajectoryApiTrajectoriesImportPostResponse200 & {
    headers: Headers;
  };
export type importLangsmithTrajectoryApiTrajectoriesImportPostResponseError =
  importLangsmithTrajectoryApiTrajectoriesImportPostResponse422 & {
    headers: Headers;
  };

export type importLangsmithTrajectoryApiTrajectoriesImportPostResponse =
  | importLangsmithTrajectoryApiTrajectoriesImportPostResponseSuccess
  | importLangsmithTrajectoryApiTrajectoriesImportPostResponseError;

export const getImportLangsmithTrajectoryApiTrajectoriesImportPostUrl = () => {
  return `/api/trajectories/import`;
};

/**
 * Store a LangSmith export as a trajectory (TRA-1087, path 2).
 *
 * For runs recorded before the client sent `X-Langsmith-Run-Id` there is
 * no gateway trace to find, so the user uploads the run's LangSmith
 * export instead. The gateway turns it into the same records live
 * traffic leaves behind; from then on the run lists, opens, reviews and
 * feeds evals like any other. The export travels as parsed JSON inside
 * the request body (the browser reads the file), not as multipart.
 *
 * The upload never leaves the run sitting only in the Trajectories list:
 * the uploader's review (when given) is saved as a reviewed label on the
 * run's first turn, and otherwise the run is flagged for the review queue
 * (see `record_upload_feedback`).
 * @summary Import Langsmith Trajectory
 */
export const importLangsmithTrajectoryApiTrajectoriesImportPost = async (
  trajectoryImportRequest: TrajectoryImportRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<importLangsmithTrajectoryApiTrajectoriesImportPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<importLangsmithTrajectoryApiTrajectoriesImportPostResponse>(
    getImportLangsmithTrajectoryApiTrajectoriesImportPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(trajectoryImportRequest),
    },
  );
};

export const getImportLangsmithTrajectoryApiTrajectoriesImportPostMutationKey =
  () => ["importLangsmithTrajectoryApiTrajectoriesImportPost"] as const;

export const getImportLangsmithTrajectoryApiTrajectoriesImportPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importLangsmithTrajectoryApiTrajectoriesImportPost>
      >,
      TError,
      ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof importLangsmithTrajectoryApiTrajectoriesImportPost>
    >,
    TError,
    ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getImportLangsmithTrajectoryApiTrajectoriesImportPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof importLangsmithTrajectoryApiTrajectoriesImportPost>
      >,
      ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return importLangsmithTrajectoryApiTrajectoriesImportPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof importLangsmithTrajectoryApiTrajectoriesImportPost>
    >
  >;
export type ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationBody =
  TrajectoryImportRequest;
export type ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationError =
  ErrorType<HTTPValidationError>;
export type ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationVariables =
  { data: TrajectoryImportRequest };

/**
 * @summary Import Langsmith Trajectory
 */
export const useImportLangsmithTrajectoryApiTrajectoriesImportPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importLangsmithTrajectoryApiTrajectoriesImportPost>
      >,
      TError,
      ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof importLangsmithTrajectoryApiTrajectoriesImportPost>
  >,
  TError,
  ImportLangsmithTrajectoryApiTrajectoriesImportPostMutationVariables,
  TContext
> => {
  return useMutation(
    getImportLangsmithTrajectoryApiTrajectoriesImportPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
